import React from "react";

const SvgStar = ({ color, filled, ...props }) => (
  <svg width="16.457" viewBox="0 0 16.457 15.75" {...props}>
    <path
      d="M8.229.998l2.234 4.527 4.996.726-3.616 3.524.854 4.976-4.468-2.35-4.47 2.35.854-4.976L.998 6.25l4.997-.726z"
      strokeMiterlimit="4"
      fill={filled ? color : "none"}
      fillOpacity="1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="none"
      strokeDashoffset="0"
      strokeOpacity="1"
    />
  </svg>
);

export default SvgStar;
